import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { deepOrange } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  purple: {
    //color: theme.palette.getContrastText(deepPurple[500]),
    //backgroundColor: deepPurple[500],
    backgroundColor: "white",
    color: "#083EA7",
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));

export default function LetterAvatars({firstName, lastName}) {
  const classes = useStyles();
  const letter = firstName.charAt(0).concat(lastName.charAt(0));

  return (
    <div className={classes.root}>
      <Avatar className={classes.purple} >{letter}</Avatar>
    </div>
  );
}
